//=======================================================================================================================
// Utility functions
//=======================================================================================================================
import moment from "moment";

// Function for downloading data using panel columns
// @param data - This is the data that is required for csv data
// @param columns - This is the columns based on the data
// @param options - this is a json object containing options for the downloading of the file
// @param callback - this is a callback function to trigger other functions
export const downloadData = (data, columns, options, callback = () => {}) => {
  if (data && data instanceof Array && columns && columns instanceof Array) {
    if (data.length === 0 || columns.length === 0) {
      callback();
    } else {
      var convertedData = "";

      if (options.fileType === "csv" || options.fileType === "txt") {
        if (!columns[0].hasOwnProperty("tableColumn")) {
          columns.forEach((col, colIndex) => {
            convertedData += col.name;
            if (colIndex < columns.length - 1) {
              convertedData += ",";
            }
          });

          convertedData += "\r\n";
          data.forEach((row, rowIndex) => {
            columns.forEach((col, colIndex) => {
              if (row[col.selector] === null) {
              } else if (typeof row[col.selector] === "boolean") {
                convertedData += row[col.selector] ? "Yes" : "No";
              } else if (typeof row[col.selector] === "number") {
                convertedData += row[col.selector];
              } else if (row[col.selector] instanceof Date) {
                var dateTime = moment(row[col.selector]);
                if (dateTime.isValid()) {
                  convertedData += dateTime.format("YYYY-MM-DD HH:mm:ss");
                }
              } else {
                convertedData += '"' + row[col.selector] + '"';
              }
              if (colIndex < columns.length - 1) {
                convertedData += ",";
              }
            });
            convertedData += "\r\n";
          });
        } else {
          columns.forEach((col, colIndex) => {
            convertedData += col.tableColumn.description;
            if (colIndex < columns.length - 1) {
              convertedData += ",";
            }
          });

          convertedData += "\r\n";
          data.forEach((row, rowIndex) => {
            columns.forEach((col, colIndex) => {
              if (row[col.tableColumn.name] === null) {
              } else if (col.columnType === "Boolean") {
                convertedData += row[col.tableColumn.name] ? "Yes" : "No";
              } else if (col.columnType === "Int32" || col.columnType === "Int64" || col.columnType === "Double") {
                convertedData += row[col.tableColumn.name];
              } else if (col.columnType === "DateTime") {
                // TO DO: Change date format once we use different date types
                var dateTime = moment(row[col.tableColumn.name]);
                if (dateTime.isValid()) {
                  convertedData += dateTime.format("YYYY-MM-DD HH:mm:ss");
                }
              } else if (col.columnType === "dropdown" || col.columnType === "list_of_values") {
                if (typeof row[col.tableColumn.name] === "string") {
                  convertedData += row[col.tableColumn.name];
                } else {
                  var displayValue;
                  if (col.dropDownValues !== undefined || col.dropDownValues !== null) {
                    if (col.dropDownDisplayValues !== undefined || col.dropDownDisplayValues !== null) {
                      displayValue = Object.values(col.dropDownDisplayValues).filter(
                        (dropdownValue) => dropdownValue.key === row[col.tableColumn.name]
                      )[0];
                    } else {
                      displayValue = Object.values(col.dropDownValues).filter(
                        (dropdownValue) => dropdownValue.key === row[col.tableColumn.name]
                      )[0];
                    }
                  }
                  convertedData += displayValue !== undefined ? displayValue.value : "";
                }
              } else {
                convertedData += '"' + row[col.tableColumn.name] + '"';
              }
              if (colIndex < columns.length - 1) {
                convertedData += ",";
              }
            });
            convertedData += "\r\n";
          });
        }
      }

      var filename = options.fileName.trim().replaceAll(" ", "_") + "_Export." + options.fileType;
      var file = new Blob([convertedData], { type: "text/plain;charset=utf-8" });

      if (window.saveAs) {
        window.saveAs(file, filename);
      }
    }
  }
};

export const base64toBlob = (base64Data, contentType) => {
  contentType = contentType || "";
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data); //--deprecated
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
};
